import React, { Component } from 'react';
import { BrowserRouter , Route, Switch } from 'react-router-dom'
import NavBar from './components/Layout/NavBar'
import HomePage from './components/HomePage/HomePageFront'
import Privacy from './components/Layout/PrivacyTerms'
import SimpleNiceList from './components/Layout/SimpleNiceList'
import CoinFlip from './components/Layout/CoinFlip'
import TermsAndConditions from './components/Layout/TermsAndConditions';
import CoinFlipTermsAndConditions from './components/Layout/CoinFlip/TermsAndConditions';
import CoinFlipPrivacy from './components/Layout/CoinFlip/PrivacyTerms'

class App extends Component {
 
  render() {
     const haveNavbar = () => (
         <div>
            <NavBar />
                <Route exact path='/' component={ HomePage } />  
            <Switch>
                <Route path='/privacy' component={ Privacy } />
                <Route path='/terms-and-conditions' component={ TermsAndConditions } />
                <Route path='/simple-nice-list-mobile-phone-app' component={ SimpleNiceList } />
                <Route path='/coin-flip-mobile-phone-app' component={ CoinFlip } />
                <Route path='/coin-flip-app/privacy' component={CoinFlipPrivacy } />
                <Route path='/coin-flip-app/terms-and-conditions' component={ CoinFlipTermsAndConditions } />
            </Switch>
          </div>
        )
    return (
      <BrowserRouter>
        <div className="App">
           <Route exact path='/privacy' component={ haveNavbar } />
           <Route exact path='/' component={ haveNavbar } />  
           <Route path='/simple-nice-list-mobile-phone-app' component={ haveNavbar } />
           <Route path='/coin-flip-mobile-phone-app'  component={ haveNavbar }/>
           <Route path='/terms-and-conditions' component={ haveNavbar } />
           <Route path='/coin-flip-app/privacy' component={ haveNavbar } />
           <Route path='/coin-flip-app/terms-and-conditions' component={ haveNavbar } />
        </div>
      </BrowserRouter>
    )
  }
}

export default App;
